export * from './pagenotfound.component';



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/pagenotfound/index.ts